module.exports = __webpack_public_path__ + "media/images/icon_delete_tag-e93e1dc2745f03896f6bb5ebef82c74e.png";